const eventTypes = {
    screen: '0',
    dynamic_links: '1',
    document_links: '2',
    exit_links: '3',
    internal_video: '6',
    form_field: '8',
    modal: '9',
    tab: '11',
    hover: '12',
    ad_clicks: '13',
    ad_impressions: '13',
    scroll: '14',
    personalization_impression: '15',
    personalization_interaction: '16',
    personalization_click: '17',
    external_video: '21',
};
export default eventTypes;
//# sourceMappingURL=eventTypes.js.map